module.exports = __webpack_public_path__ + "static/media/map_gps_arrow_territory.5e56c637.svg";